import { GET, POST, PUT, DELETE, download, uploading, POSTFormData, EXPORT, DELETEBODY } from '@/request/http'

//模板上传
export const templateUpload = p => POSTFormData('/cloudprint/templateInfo/upload', p)
//获取模板类型
export const findTemplateType = p => GET('/cloudprint/templateInfo/type', p)
//获取模板list
export const findTemplateList = p => GET('/cloudprint/templateInfo', p)
//删除模板
export const deleteTemplate = p => DELETEBODY('/cloudprint/templateInfo', p)

// 驾校
//查询list
export const findAdmissionCardList = p => GET('/cloudprint/admissionCardInfo', p)
//获取考试科目
export const findSubject = p => GET('/cloudprint/admissionCardInfo/subject', p)
//获取车型
export const findCarType = p => GET('/cloudprint/admissionCardInfo/carType', p)
//获取场地
export const findExamAddress = p => GET('/cloudprint/admissionCardInfo/examAddress', p)
//模板下载
export const importModelUpload = p => download('/cloudprint/admissionCardInfo/template', p)
//文件导入
export const drivingImport = p => POSTFormData('/cloudprint/admissionCardInfo/import', p)
//批量删除，单文件删除
export const deleteCardInfo = p => DELETEBODY('/cloudprint/admissionCardInfo', p)
//修改信息
export const editCardInfo = p => PUT('/cloudprint/admissionCardInfo', p)



// WEBPACK FOOTER //
// ./src/api/modules/cloudPrinting.js